import { defineMessages } from '@redbubble/next/intl';

export const artistBadgeMessages = defineMessages({
  fanArtBadgeText: {
    defaultMessage: 'Fan Artist',
  },
  featuredBadgeText: {
    defaultMessage: 'Featured Artist',
  },
});
